import { apiCallCenter, apiAgi } from '@/plugins/axios'

export default {
  getDepartamento () {
    return apiCallCenter().get('/relatorios/monitor/operador/departamento')
  },
  getOperador () {
    return apiCallCenter().get('/relatorios/monitor/operador/operadores')
  },
  acoesOperador(data) {
    return apiCallCenter().post('/agent/login', data)
  },
  getFilas() {
    return apiCallCenter().get('/relatorios/monitor/operador/queue')
  },
  getPausas() {
    return apiCallCenter().get('/relatorios/monitor/pausas/lazy')
  },
  spyChannel(data) {
    return apiAgi().post('/click-to-call/spy', data)
  },
}